import { useEffect } from "react";
import { Carousel } from "bootstrap";
import "./Hero.css"
import img1 from "../../assets/images/Elect-carousel.png"
import img2 from "../../assets/images/Plumber-carousel.png"
import img3 from "../../assets/images/AC-carousel.png"
import img4 from "../../assets/images/Fridge-carousel.png"
import img5 from "../../assets/images/washing-carousel.png"
import img6 from "../../assets/images/carpenter-carousel.png"
const Hero = () => {
  useEffect(() => {
    const element = document.querySelector("#carouselExampleFade");

    new Carousel(element, {
      interval: 5000,
      ride: "carousel",
      pause: false,
      wrap: true
    });
  }, []);
  return (
    <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel" >
      <div className="carousel-inner">
        <div className='carousel-item active'>
          <img src={img1} alt="" className='d-block w-100' />
          <div className="service-badge">
            ⚡ <br/>
            <span>Within Same Day Service</span>
          </div>
          <div className="carousel-caption custom-caption">
            <div className="caption-content">
              <h1>Easy Electric Fix</h1>
              <p>Professional wiring and repair services you can trust.</p>
              <div className="hero-buttons">
                <a 
                href="https://wa.me/917661045308"
                 className="btn whatsapp-btn btn-success mx-1" 
                 target="_blank"
                 rel="noopener noreferrer"
                 >
                  Whatsapp <i className="bi bi-whatsapp mx-1"></i>
                </a>
                <a href="tel:+917661045308" className="btn btn-dark mx-1">
                  Call Us <i className="bi bi-telephone mx-1"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/*Item 2 */}
        <div className='carousel-item '>
          <img src={img2} alt="" className='d-block w-100' />
          <div className="service-badge">
            ⚡ <br/>
            <span>Within Same Day Service</span>
          </div>
          <div className="carousel-caption custom-caption">
            <div className="caption-content">
              <h1>Reliable Plumbing</h1>
              <p>Quick leak fixes and quality pipe installations.</p>
              <div className="hero-buttons">
                <a
                  href="https://wa.me/917661045308"
                  className="btn whatsapp-btn btn-success mx-1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Whatsapp <i className="bi bi-whatsapp"></i>
                </a>
                <a href="tel:+917661045308" className="btn btn-dark mx-1">
                  Call Us <i class="bi bi-telephone"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/*Item 3 */}
        <div className='carousel-item'>
          <img src={img3} alt="" className='d-block w-100' />
          <div className="service-badge">
            ⚡ <br/>
            <span>Within Same Day Service</span>
          </div>
          <div className="carousel-caption custom-caption">
            <div className="caption-content">
              <h1>Cool Air Promise</h1>
              <p>Fast and efficient AC servicing at your doorstep.</p>
              <div className="hero-buttons">
                <a href="https://wa.me/917661045308" className="btn whatsapp-btn btn-success mx-1">
                  Whatsapp <i class="bi bi-whatsapp"></i>
                </a>
                <a href="tel:+917661045308" className="btn btn-dark mx-1">
                  Call Us <i class="bi bi-telephone"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/*Item 4 */}
        <div className='carousel-item '>
          <img src={img4} alt="" className='d-block w-100' />
          <div className="service-badge">
            ⚡ <br/>
            <span>Within Same Day Service</span>
          </div>
          <div className="carousel-caption custom-caption">
            <div className="caption-content">
              <h1>Fast Fridge Repair</h1>
              <p>Keep your food fresh with expert repair.</p>
              <div className="hero-buttons">
                <a href="https://wa.me/917661045308" className="btn whatsapp-btn btn-success mx-1">
                  Whatsapp <i class="bi bi-whatsapp"></i>
                </a>
                <a href="tel:+917661045308" className="btn btn-dark mx-1">
                  Call Us <i class="bi bi-telephone"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/*Item 5 */}
        <div className='carousel-item '>
          <img src={img5} alt="" className='d-block w-100' />
          <div className="service-badge">
            ⚡ <br/>
            <span>Within Same Day Service</span>
          </div>
          <div className="carousel-caption custom-caption">
            <div className="caption-content">
              <h1>Smart Wash Care</h1>
              <p>Expert washing machine repair service.</p>
              <div className="hero-buttons">
                <a href="https://wa.me/917661045308" className="btn whatsapp-btn btn-success mx-1">
                  Whatsapp <i class="bi bi-whatsapp"></i>
                </a>
                <a href="tel:+917661045308" className="btn btn-dark mx-1">
                  Call Us <i class="bi bi-telephone"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/*Item 6 */}
        <div className='carousel-item '>
          <img src={img6} alt="" className='d-block w-100' />
          <div className="service-badge">
            ⚡ <br/>
            <span>Within Same Day Service</span>
          </div>
          <div className="carousel-caption custom-caption">
            <div className="caption-content">
              <h1>Perfect Wood Craft</h1>
              <p>Quality carpentry for modern homes.</p>
              <div className="hero-buttons">
                <a href="https://wa.me/917661045308" className="btn whatsapp-btn btn-success mx-1">
                  Whatsapp <i class="bi bi-whatsapp"></i>
                </a>
                <a href="tel:+917661045308" className="btn btn-dark mx-1">
                  Call Us <i class="bi bi-telephone"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Hero;
